<div class="kng-count-of-item-card {{ state?.cssClass }}">

  <div class="container">
    <p class="error" *ngIf="state?.error && !state?.loading" tabindex="0">
     {{state?.error}}
    </p>
    <p *ngIf="state?.loading" class="loader">
      <img  src="{{loaderState.imagePath }}" tabindex="0" alt="loader" />
     </p>
     <ng-container *ngIf="state?.comingSoon">
      <p class="card-title no-margin">{{comingSoon.title}}</p>
     <p class="coming-soon no-margin"  tabindex="0">
      <img  src="{{comingSoon.imagePath }}" tabindex="0" alt="comingSoon" />
     </p>
     <p class="coming-soon-text no-margin"  tabindex="0">
      {{comingSoon.imageText}}
     </p>
    </ng-container>
    <div
      class="title-row"
      *ngIf="!state?.loading && !state?.error && (state?.cardType === 'unitCard' || state?.cardType === 'amountCard')"
    >
      <div
        class="card-title" tabindex="0"
        [ngClass]="{ 'unit-title': state?.cardType === 'unitCard' }"
      >
        {{ state?.title?.label }}
      </div>
    </div>
    <div *ngIf="state?.unit && !state?.loading && !state?.error && (state?.cardType === 'unitCard' || state?.cardType === 'stackedCard') ">
      <div class="d-flex align-items-flex-end kng-count-of-item-card--content-container" *ngFor="let u of state?.unit">
        <div class="title-marg-{{ state?.cardType }}">
          <div
            class="card-icon"
            *ngIf="
              state?.cardType === 'unitCard' &&
              state?.image &&
              state?.image?.url !== ''
            "
          >
            <img src="{{ state?.image?.url }}" alt="{{ state?.image?.alt }}" />
          </div>
          <div
            [ngClass]="{
              'd-flex align-items-flex-end':
                state?.cardType === 'unitCard'
            }"
            tabindex="0">
            <div
              class="card-text"
              [ngClass]="{ 'icon-padding': state?.cardType === 'unitCard' }" tabindex="-1"
            >
              {{ u.label }}
            </div>
            <div class="card-units card-unit-padding-{{ state?.cardType }}" tabindex="-1">
              {{ u?.description?.label }}
              <span *ngIf="u?.description?.label === 'Open Quotes' || u?.description?.label === 'Active Equipment Orders'">
                <img matTooltipPosition="right" matTooltip="{{u?.tooltip}}" tabindex="0"  attr.aria-label="{{ u?.tooltip }}"
                  class="desktop-view" matTooltipClass="cardTooltip" #tooltipdesktop="matTooltip"
                  attr.aria-label="" alt="info icon" src="assets/info_desktop.svg"
                  matTooltipClass="chartTooltip"
                  matTooltipPositionAtOrigin="true">
                <img id="tooltip-{{u.description.label}}" matTooltipPosition="below" tabindex="0" (click)="showTooltip()"
                  attr.aria-label="{{ u.tooltip }}" class="mobile-view" alt="info icon"
                  src="assets/info_mobile.svg">
              </span>
            </div>
          </div>
        </div>
        <div
          class="d-flex align-items-flex-end icon-padding-{{ state?.cardType }}" tabindex="-1"
        >
          <div class="card-amount"  tabindex="0">{{ u?.amount | currency: u?.currency :"symbol":"1.2-2" }}</div>
        </div>
      </div>
    </div>
    <div *ngIf="state?.unit && !state?.loading && !state?.error && state?.cardType === 'amountCard'">
      <div class="d-flex kng-count-of-item-card--content-container" *ngFor="let u of state?.unit">
        <div class="title-marg-{{ state?.cardType }}">
          <div [ngClass]="{'d-flex align-items-flex-end': state?.cardType === 'amountCard'}" tabindex="0">
            <div class="card-units card-unit-padding-{{ state?.cardType }}" tabindex="-1">
              {{ u.description.label }}
            </div>
          </div>
        </div>
        <div class="label-amount" tabindex="-1">
          <div class="card-text" [ngClass]="{ 'icon-padding': state?.cardType === 'amountCard' }" tabindex="-1">
            {{ u.label | number }}
          </div>
          <div class="card-amount"  tabindex="0">
            {{ (u.amount !== '—') ? ( u.amount | currency: u?.currency :"symbol":"1.2-2") : '—' }}
          </div>
        </div>
      </div>
    </div>
    
    <div class="connected-count-card--section"  *ngIf="!state?.loading && state?.cardType === 'connectedCountCard' ">
      <ng-container *ngIf="!state?.error">
      <div class="connected--title" tabindex="0">
        {{ state?.title?.label }}
      </div>
      <div *ngFor="let data of state?.unit" class="card-value-section">
        <div class="card--icon" tabindex="0">
          <img src="{{ state?.image?.url }}" alt="{{ state?.image?.alt }}" />
        </div>
        <div class="data--section">
          <div class="total-count-section" tabindex="0" *ngIf="data.label !== ''">
            <div class="totalcount--value">{{ data.label }}</div>
            <div class="totalcount--label">{{ data.description.label }}</div>
          </div>
          <div class="connected-count-section" tabindex="0" *ngIf="data.connectedCount?.value !=='' ">
            <div class="connected--icon"><img src="{{ data.connectedCount?.icon?.url }}" alt="{{ data.connectedCount?.icon?.alt }}" aria-label="MyInsights_Logo"/></div>
            <div class="connected-count--value">{{ data.connectedCount?.value }}</div>
            <div class="connected-count--label">{{ data.connectedCount?.label }}</div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #else>{{state?.error}}</ng-template>
  </div>
</div>
